<template>
    <div>
        <div v-if="formSubmitted" class="text-center">
            <div class="d-inline-block checked-mark circle small mb-3">
                <i class="fas fa-check center"></i>
            </div>
            <p class="text-success font-size-small mb-0">{{$t('general.resend_email_verification_success')}}</p>
        </div>
        <div v-else>
            <h1>{{$t('general.resend_email_verification')}}</h1>
            <form @submit.prevent="submit">
                <google-recaptcha-v3
                    v-on:input="updateRecaptcha"
                    ref="captchaVerificationLink"
                    :site-key="this.$recaptchaKey"
                    id="verification_link_id"
                    action="verification_link"
                ></google-recaptcha-v3>
                <input-with-validation
                    :value="item.email"
                    :title="$t('fields.email')"
                    :name="'email'"
                    :style-class="'form-control'"
                    :type="'email'"
                    :errors="errors"
                    :use-u-i-d="true"
                    :name-type="'placeholder'"
                    @onInput="changeEmail"/>
                <div class="custom-error-message" v-if="errors && errors.error_message">
                    <p>{{errors.error_message}}</p>
                </div>
                <button class="btn btn-primary w-100 mb-0" type="submit" :disabled="loading">
                    <span v-if="!loading">
                        {{ $t('general.send_email_verification_link')}}
                    </span>

                    <div class="spinner-border loading-spinner" role="status" v-if="loading">
                        <span class="sr-only"></span>
                    </div>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import GoogleRecaptchaV3 from "../../components/googlerecaptchav3/GoogleReCaptchaV3";
    import Vue from 'vue';

    export default {
        components: {GoogleRecaptchaV3},
        data() {
            return {
                data: [],
                formSubmitted: false,
                errors: null,
            }
        },
        computed: {
            ...mapGetters('EmailVerificationResendFormSingle', ['item', 'loading']),
        },
        created() {
            this.init();
            var app = this;
            this.$vueEventBus.$on('clear-errors', function () {
                app.errors = null;
            });
        },
        methods: {
            ...mapActions('EmailVerificationResendFormSingle', ['send', 'setEmail', 'resetState', 'setgRecaptchaResponse']),
            changeEmail(event) {
                this.setEmail(event.target.value);
            },
            updateRecaptcha(response) {
                this.setgRecaptchaResponse(response);
            },
            submit() {
                this.send().then(response => {
                    this.formSubmitted = true;
                    this.$refs.captchaOrderACall.execute();
                }).catch(error => {
                    this.errors = error.response.data.errors;
                    if (typeof this.errors === "undefined") {
                        this.errors = {};
                    }
                    if(error.response.data.error_message) {
                        Vue.set(this.errors,'error_message',error.response.data.error_message);
                    }
                    this.$refs.captchaOrderACall.execute();
                })
            },
            init() {
                this.errors = null;
                this.formSubmitted = false;
                this.resetState();
            }
        }
    }
</script>
